import React from 'react';
import PropTypes from 'prop-types';
import { useMediaQuery } from 'react-responsive';

import { MEDIA_QUERY_SMALL_SCREEN } from 'client/constants/mediaQueries';

import SrBox from 'client/components/SrBox';
import SrLabel, { SR_LABEL_THEME_GREEN_CHECKMARK_V2 } from 'client/components/SrLabel/SrLabel';

const PartnerAgentOwnerMarketingPageChecklist = ({ partner }) => {
  const isSmallScreen = useMediaQuery({
    query: MEDIA_QUERY_SMALL_SCREEN,
  });

  const checklistItems = [
    'Your personalized Marketing Page',
    'How Sunroom Works',
    '5-star testimonials',
    'Mobile optimized',
  ];

  return (
    <SrBox boxSizing="border-box" position="relative">
      <SrBox
        backgroundColor="white"
        borderRadius="12px"
        width={isSmallScreen ? '264px' : '370px'}
        height={isSmallScreen ? '234px' : '328px'}
        position="relative"
      >
        <SrBox
          borderRadius="8px"
          boxSizing="border-box"
          padding="8px"
          overflow="hidden"
          margin="-31px 0 0 16px"
          display="inlineBlock"
          backgroundColor="white"
          boxShadow="0px 2.1396px 3.56599px rgba(9, 61, 27, 0.08)"
        >
          <img src={partner.logoUrl} alt="partner logo" height={isSmallScreen ? '62px' : '67px'} />
        </SrBox>
        <SrBox width="300px" position="absolute" top={isSmallScreen ? '65px' : '75px'} left="16px">
          {checklistItems.map((item, index) => (
            <SrBox
              minWidth={isSmallScreen ? '264px' : '370px'}
              position="absolute"
              top={isSmallScreen ? `${index * 50}px` : `${index * 70}px`}
            >
              <SrLabel
                theme={SR_LABEL_THEME_GREEN_CHECKMARK_V2}
                label={item}
                fontSize={isSmallScreen ? 'small' : 'large'}
              />
            </SrBox>
          ))}
        </SrBox>
      </SrBox>
    </SrBox>
  );
};

PartnerAgentOwnerMarketingPageChecklist.propTypes = {
  partner: PropTypes.object.isRequired,
};

PartnerAgentOwnerMarketingPageChecklist.displayName = 'PartnerAgentOwnerMarketingPageChecklist';

export default PartnerAgentOwnerMarketingPageChecklist;
